import axios, {getDeviceAuthFallback} from './axios';

const deleteById = async (id) => {

    return axios.delete(`photos/${id}`, {headers: headers()});
};

const getAll = async () => {

    return axios.get(`photos`, {headers: headers()}).then(response => response.data).then(data => ({items: prepare(data)}));
};

const getById = async (id) => {

    return axios.get(`photos/${id}`, {headers: headers()}).then(response => response.data).then(data => ({item: prepare(data)}));
};

const getByParameters = async (params) => {

    return axios.get(`photos`, {params, headers: headers()}).then(response => response.data).then(data => ({items: prepare(data)}));
};

const headers = () => {

    return Object.assign({}, axios.defaults.headers, {

        common: Object.assign({}, axios.defaults.headers.common, {

            Authorization: getDeviceAuthFallback(),
        }),
    });
};

const prepare = (items) => {

    const wasArray = Array.isArray(items);

    items = (wasArray ? items : [items]).map(item => {

        const filename = 'https://growapp.geodan.nl/uploads/' + item.filename;
        const cacheBuster = window.localStorage.getItem('cacheBuster_' + filename);

        Object.defineProperty(item, 'cacheBuster', {

            set: function(value) {

                this.filename = filename + `?${value}`;
                window.localStorage.setItem('cacheBuster_' + filename, value);
            },
        });

        return Object.assign(item, {

            filename: filename + `?${cacheBuster || ''}`,
        });
    });

    return wasArray ? items : items[0];
};

const save = ({uri, accuracy, description, latitude, longitude, photoSetId, rotate, tags, device}) => {

    // TODO GEODAN: return photo in the same format as GET /photos and PUT /photos/:id.

    if (tags && tags.length > 0)
        description = (description || '') + ' #' + tags.join(' #');

    return axios.post(`photos`, {

        accuracy,
        description,
        devicehash: device.devicehash, // TODO GEODAN: don't require device info in body.
        deviceid: device.deviceid,
        latitude,
        longitude,
        photo: uri,
        rootid: photoSetId,
        rotate,
        // tags, // Only used for predefined tags.

    }, {headers: headers()}).then(response => response.data).then(data => ({item: prepare(data)}));
};

const updateById = async (id, {description, rotate, tags}) => {

    return axios.put(`photos/${id}`, {

        description,
        rotate,
        // tags, // Only used for predefined tags.

    }, {headers: headers()}).then(response => response.data).then(data => ({item: prepare(data)}));
};

export {

    deleteById,
    getAll,
    getById,
    getByParameters,
    save,
    updateById,
}



// WEBPACK FOOTER //
// ./src/components/services/photos.js